import { Check, Lock, AlertTriangle, Minus } from "lucide-react";
import { statusLabel } from "@/lib/workflow";

const dot = {
  not_started: "bg-white border-slate-300 text-slate-400",
  in_progress: "bg-blue-600 border-blue-600 text-white",
  blocked: "bg-red-600 border-red-600 text-white",
  completed: "bg-slate-900 border-slate-900 text-white",
  not_applicable: "bg-amber-100 border-amber-300 text-amber-700",
};

function Icon({ phase }) {
  if (phase.key === "erp_handover" && !phase.gate_ok && phase.status === "not_started") return <Lock className="h-3 w-3" />;
  if (phase.status === "completed") return <Check className="h-3 w-3" />;
  if (phase.status === "blocked") return <AlertTriangle className="h-3 w-3" />;
  if (phase.status === "not_applicable") return <Minus className="h-3 w-3" />;
  return <span className="text-[10px] font-semibold">{phase.order + 1}</span>;
}

export const PhaseTimeline = ({ phases, selectedId, onSelect }) => (
  <div className="relative" data-testid="phase-timeline">
    <div className="absolute left-0 right-0 top-[14px] h-px bg-slate-200" />
    <div className="relative grid grid-cols-4 lg:grid-cols-8 gap-y-5">
      {phases.map((p) => {
        const active = p.phase_id === selectedId;
        return (
          <button
            key={p.phase_id}
            onClick={() => onSelect(p.phase_id)}
            data-testid={`timeline-phase-${p.key}`}
            className="group flex flex-col items-center text-center px-1 focus:outline-none"
          >
            <span
              className={`h-7 w-7 rounded-full border-2 grid place-items-center transition-transform group-hover:scale-110 ${dot[p.status]} ${
                active ? "ring-4 ring-blue-100" : ""
              }`}
            >
              <Icon phase={p} />
            </span>
            <span className={`mt-2 text-[11px] leading-tight ${active ? "font-semibold text-slate-900" : "text-slate-600"}`}>{p.name}</span>
            <span className="mt-0.5 text-[10px] text-slate-400">{statusLabel(p.status)}</span>
          </button>
        );
      })}
    </div>
  </div>
);
